import MailReplyComposer from './MailReplyComposer';
import { DataState } from '../../context/DataProvider';
import { draftReplyEmail, replyToEmail } from '../../services/email_api';

const addressOf = (s) => {
  if (typeof s === 'string') return s;
  return (
    s?.contact ||
    s?.emailAddress?.address ||
    s?.emailAddress?.name ||
    s?.email ||
    s?.address ||
    s?.name ||
    ''
  );
};

/** The reply editor for a mail from the user's connected mailbox. */
const BriefingReplyEmail = ({
  onClose,
  sender,
  message_id,
  messageBody,
  setMessageBody,
  localAttachments,
  driveAttachments,
  setLocalAttachments,
  setDriveAttachments,
  customPrompt,
  setCustomPrompt,
  isOutlook,
}) => {
  const { userGoogleId } = DataState();

  const send = async ({ recipients, ccs, bccs }) => {
    const formData = new FormData();
    recipients.forEach((email) => formData.append('recipients', email));
    ccs.forEach((email) => formData.append('ccs', email));
    bccs.forEach((email) => formData.append('bccs', email));

    formData.append('message_id', message_id);
    if (messageBody) {
      formData.append('message_body', messageBody);
    }
    if (localAttachments.length > 0) {
      localAttachments.forEach((file) => {
        formData.append('files', file);
      });
    }
    const driveFileIds = driveAttachments.map((file) => file.id);
    driveFileIds.forEach((id) => formData.append('google_drive_file_ids', id));

    await replyToEmail(userGoogleId, formData, isOutlook);
  };

  const generate = async (prompt) => {
    const response = await draftReplyEmail(
      userGoogleId,
      message_id,
      prompt,
      isOutlook,
    );
    return response?.html_body || '';
  };

  return (
    <MailReplyComposer
      onClose={onClose}
      initialRecipients={
        sender
          ?.map(addressOf)
          .filter((e) => typeof e === 'string' && e.trim() !== '') || []
      }
      messageBody={messageBody}
      setMessageBody={setMessageBody}
      localAttachments={localAttachments}
      driveAttachments={driveAttachments}
      setLocalAttachments={setLocalAttachments}
      setDriveAttachments={setDriveAttachments}
      customPrompt={customPrompt}
      setCustomPrompt={setCustomPrompt}
      onSend={send}
      onGenerate={generate}
    />
  );
};

export default BriefingReplyEmail;
